var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { ScreenLayout } from '@/components/ScreenLayout';
import TabBar from '@/components/TabBar';
import useAppComponents from '@/hooks/useAppComponents';
import Logger from '@/logging/Logger';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import ClubQuestCheckInCompleteModal from './components/ClubQuestCheckInCompleteModal';
import WelcomeModal from './components/WelcomeModal';
import { tabItems } from './constants';
import CrusherActivitySeasonView from './views/CrusherActivitySeasonView';
import HistoryView from './views/HistoryView';
const QR_CODE = '2025-autumn'; // qr is deprecated
export default function CrusherActivityScreen({ route, }) {
    var _a, _b;
    const params = route.params;
    const { api } = useAppComponents();
    const queryClient = useQueryClient();
    const [visibleCheckInCompleteModal, setVisibleCheckInCompleteModal] = useState(false);
    const [recordStatus, setRecordStatus] = useState('idle');
    function recordCrusherClubActivity(questTypeOrActivityId) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecordStatus('loading');
            try {
                yield api.recordCrusherClubActivityPost({
                    questTypeOrActivityId,
                });
                // 진행 중인 쿼리를 취소하고 새로운 fetch를 실행하여 race condition 방지
                yield queryClient.cancelQueries({
                    queryKey: ['CrusherActivityPageData'],
                });
                yield queryClient.fetchQuery({
                    queryKey: ['CrusherActivityPageData'],
                    queryFn: () => __awaiter(this, void 0, void 0, function* () { return (yield api.getCrusherActivityPageDataPost()).data; }),
                });
                setRecordStatus('success');
            }
            catch (error) {
                setRecordStatus('idle');
                Logger.logError(error);
            }
        });
    }
    useEffect(() => {
        // 하위호환을 위해 qr을 남겨둔다.
        if ((params === null || params === void 0 ? void 0 : params.qr) === QR_CODE) {
            recordCrusherClubActivity('STARTING_DAY');
        }
    }, [params === null || params === void 0 ? void 0 : params.qr]);
    useEffect(() => {
        if (params === null || params === void 0 ? void 0 : params.questTypeOrActivityId) {
            recordCrusherClubActivity(params.questTypeOrActivityId);
        }
    }, [params === null || params === void 0 ? void 0 : params.questTypeOrActivityId]);
    function checkInToClubQuest() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(params === null || params === void 0 ? void 0 : params.clubQuestIdToCheckIn)) {
                return;
            }
            try {
                yield api.checkInToClubQuestPost({
                    clubQuestId: params.clubQuestIdToCheckIn,
                });
                // 진행 중인 쿼리를 취소하고 새로운 fetch를 실행하여 race condition 방지
                yield queryClient.cancelQueries({
                    queryKey: ['CrusherActivityPageData'],
                });
                yield queryClient.fetchQuery({
                    queryKey: ['CrusherActivityPageData'],
                    queryFn: () => __awaiter(this, void 0, void 0, function* () { return (yield api.getCrusherActivityPageDataPost()).data; }),
                });
                setVisibleCheckInCompleteModal(true);
            }
            catch (error) {
                Logger.logError(error);
            }
        });
    }
    useEffect(() => {
        if (params === null || params === void 0 ? void 0 : params.clubQuestIdToCheckIn) {
            checkInToClubQuest();
        }
    }, [params === null || params === void 0 ? void 0 : params.clubQuestIdToCheckIn]);
    const { data } = useQuery({
        queryKey: ['CrusherActivityPageData'],
        queryFn: () => __awaiter(this, void 0, void 0, function* () { return (yield api.getCrusherActivityPageDataPost()).data; }),
        staleTime: 1000 * 5,
    });
    const crewType = (_a = data === null || data === void 0 ? void 0 : data.currentCrusherActivity) === null || _a === void 0 ? void 0 : _a.crusherClub.crewType;
    const crusherActivityHistories = data === null || data === void 0 ? void 0 : data.crusherActivityHistories;
    const [currentTab, setCurrentTab] = useState('current');
    useEffect(() => {
        setCurrentTab(crewType ? 'current' : 'history');
    }, [crewType]);
    function renderView() {
        switch (currentTab) {
            case 'current':
                return _jsx(CrusherActivitySeasonView, {});
            case 'history':
                return (_jsx(HistoryView, { crusherActivityHistories: crusherActivityHistories, isCurrentCrew: !!crewType }));
        }
    }
    return (_jsxs(ScreenLayout, { isHeaderVisible: true, children: [crewType && (_jsx(TabBar, { items: tabItems, current: currentTab, onChange: setCurrentTab })), renderView(), _jsx(WelcomeModal, { questTypeOrActivityId: (params === null || params === void 0 ? void 0 : params.qr) === QR_CODE
                    ? 'STARTING_DAY'
                    : params === null || params === void 0 ? void 0 : params.questTypeOrActivityId, recordStatus: recordStatus, season: (_b = data === null || data === void 0 ? void 0 : data.currentCrusherActivity) === null || _b === void 0 ? void 0 : _b.crusherClub.season }), _jsx(ClubQuestCheckInCompleteModal, { visible: visibleCheckInCompleteModal, onClose: () => setVisibleCheckInCompleteModal(false) })] }));
}
